import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Breadcrumb, Tabs, Button, Modal, Select } from "antd";

import Main from "../../components/layout/Main";
import BreadcrumbArrow from "../../assets/images/breadcrumb-image-arrow.svg";
import TrophiesImage from "../../assets/images/trofies-image.svg";
import ProfileImage from "../../assets/images/for-prodile-player.jpg";
import CalanderchackGreen from "../../assets/images/calander-check-green.svg";
import CalanderchackRed from "../../assets/images/calander-check-red.svg";
import CalanderchackWhite from "../../assets/images/calendar-check-white.svg";
import TeamredBg from "../../assets/images/team-red-background.svg";
import Teamredbanner from "../../assets/images/team-red-banner.svg";
import TeamredLogoFox from "../../assets/images/fox-logo.svg";
import LiningImage from "../../assets/images/line & dot.svg";
import TeamredLogoBull from "../../assets/images/bull-logo.svg";
import WinnerCrownIcon from "../../assets/images/winner-crown-icon.svg";
import { useTournament } from "../../context/TournamentContext";
import { useParams, useLocation } from "react-router-dom";
import { Severty, ShowToast } from "../../helper/toast";
import moment from "moment";
import { getDiff, isValidUrl } from "../../helper/functions";
import CommonBreadcrumb from "../../components/BreadCrumb";
import ShareModal from "../../components/ShareModal";
import { shareProfile } from "../../utils/share";
import UniversalShareModal from "../../components/UniversalShareModal";
import JoinTournamentModal from "../../components/JoinTournamentModal";
import { useAuth } from "../../context/AuthContext";

const { TabPane } = Tabs;

const TournamentsDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [timeLeft, setTimeLeft] = useState("");
  const { id } = useParams();
  const { registerTournament, loadTournament, viewBrackets } = useTournament();
  const { getProfile, getConnections } = useAuth();
  const [tournamentData, setTournament] = useState({});
  const [activeTab, setActiveTab] = useState("bracket");
  const [brackets, setBrackets] = useState([]);
  const [rules, setRules] = useState();
  const [shareOpen, setShareOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [profile, setProfile] = useState();
  const [teamJoinOpen, setTeamJoinOpen] = useState(false);
  const [teamInviteOptions, setTeamInviteOptions] = useState([]);
  const [selectedInviteeIds, setSelectedInviteeIds] = useState([]);
  const [loadingConnections, setLoadingConnections] = useState(false);
  const tournament = location.pathname.split("/")[1];

  // -------- Handlers --------
  const handleRegister = async (tournamentId) => {
    try {
      if (tournamentData.isRegisterTournament === true) {
        navigate(`/lobby-tournaments/${tournamentId}`);
        return;
      }

      const response = await registerTournament({ tournamentId });
      if (response.status === 200 || response.status === 201) {
        ShowToast(response.message, Severty.SUCCESS);
        navigate(`/lobby-tournaments/${tournamentId}`);
      }
    } catch (error) {
      ShowToast(error.message, Severty.ERROR);
    }
  };

  // ------- Fetch Tournament --------
  const fetchTournament = async () => {
    try {
      const profileData = await getProfile();
      if (profileData.status === 200) {
        setProfile(profileData.data);
      }

      const response = await loadTournament(id);
      if (response.data.status === 200) {
        const data = response.data.data.tournament;
        setTournament(data);
      }
      const result = await viewBrackets(id);
      if (result.data.status === 200) {
        setBrackets(result.data.data.bracket);
        setRules(result.data.data.tournament.rules);
      }
    } catch (error) {
      console.error("Error loading tournament", error);
    }
  };

  // ----------  Use Effects ----------
  useEffect(() => {
    fetchTournament();
  }, []);

  useEffect(() => {
    if (!tournamentData?.startDate) return;
    setTimeLeft(getDiff(tournamentData.startDate, new Date()));

    const timer = setInterval(() => {
      setTimeLeft(getDiff(tournamentData.startDate, new Date()));
    }, 1000);

    return () => clearInterval(timer);
  }, [tournamentData?.startDate]);

  const isDoubleElimination = tournamentData?.eliminationType === "Double";
  const canSoloJoin =
    tournamentData?.allowSolo === undefined || tournamentData?.allowSolo;
  const entryFee = Number(tournamentData?.entryFee) || 0;
  const tokenLabel = tournamentData?.token ?? "Tokens";
  const totalPlayerSize = Number(tournamentData?.totalPlayerSize) || 1;
  const maxSelectableFriends = totalPlayerSize > 1 ? totalPlayerSize - 1 : 0;
  const balance = Number(profile?.balance) || 0;
  const totalPlayersInTeam = selectedInviteeIds.length + 1;
  const totalTeamFee = entryFee * totalPlayersInTeam;
  const hasEnoughBalanceForTeam = balance >= totalTeamFee;
  // const isExactTeamSize =
  //   totalPlayerSize > 0 ? totalPlayersInTeam === totalPlayerSize : true;
  const isExactTeamSize =
    !canSoloJoin && totalPlayerSize > 0
      ? totalPlayersInTeam === totalPlayerSize
      : true;

  const loadConnectionsForTeamJoin = async () => {
    if (!profile?._id || teamInviteOptions.length > 0) return;
    setLoadingConnections(true);
    try {
      const [followersRes, followingRes] = await Promise.all([
        getConnections({ filter: "followers", id: profile._id }),
        getConnections({ filter: "following", id: profile._id }),
      ]);

      const followers = followersRes?.data?.data || [];
      const following = followingRes?.data?.data || [];

      const mergedMap = new Map();
      [...followers, ...following].forEach((user) => {
        if (user?._id && !mergedMap.has(user._id)) {
          mergedMap.set(user._id, user);
        }
      });

      setTeamInviteOptions(Array.from(mergedMap.values()));
    } catch (error) {
      console.error("Error loading connections for team join", error);
    } finally {
      setLoadingConnections(false);
    }
  };

  const handleOpenTeamJoin = async () => {
    if (tournamentData.isRegisterTournament === true) {
      navigate(`/lobby-tournaments/${id}`);
      return;
    }

    if (!totalPlayerSize || totalPlayerSize <= 1) {
      ShowToast(
        "This tournament does not support team joining.",
        Severty.ERROR,
      );
      return;
    }

    await loadConnectionsForTeamJoin();
    setTeamJoinOpen(true);
  };

  const handleTeamInviteChange = (value) => {
    if (maxSelectableFriends && value.length > maxSelectableFriends) {
      ShowToast(
        `You can select up to ${maxSelectableFriends} friends for your team.`,
        Severty.ERROR,
      );
      return;
    }
    setSelectedInviteeIds(value);
  };

  const handleConfirmTeamJoin = async () => {
    if (!canSoloJoin && (!totalPlayerSize || totalPlayerSize <= 1)) {
      ShowToast(
        "This tournament does not support team joining.",
        Severty.ERROR,
      );
      return;
    }

    if (!isExactTeamSize) {
      ShowToast(
        `Please select exactly ${
          totalPlayerSize - 1
        } friends to complete a team of ${totalPlayerSize} players (including you).`,
        Severty.ERROR,
      );
      return;
    }

    if (!hasEnoughBalanceForTeam) {
      ShowToast(
        "You don’t have sufficient tokens to join with this many players.",
        Severty.ERROR,
      );
      return;
    }

    setTeamJoinOpen(false);
    navigate(`/lobby-tournaments/${id}`, {
      state: { inviteeUserIds: selectedInviteeIds },
    });
  };

  return (
    <Main>
      <CommonBreadcrumb
        items={[
          { title: "Tournament", url: `/${tournament}` },
          { title: "Games" },
          { title: tournamentData?.name_en },
        ]}
      />
      <div>
        <div className="games-versoin-name-header">
          <h4>Tournament Details</h4>
        </div>
        <div className="tournament-details-card">
          <div className="tournament-details-card-header">
            <h4>{tournamentData.name_en}</h4>
            <h6>
              {/* {moment(tournamentData.startDate).format("DD MMM YYYY | HH:mm A")} */}
              {tournamentData?.status === "Active"
                ? "Live"
                : tournamentData?.status === "Completed"
                  ? "Completed"
                  : "Upcoming"}
            </h6>
          </div>
          <div className="player-number">
            {`${tournamentData.totalRegisteredPlayers}/ ${
              tournamentData?.teamSize *
              (tournamentData.totalPlayerSize > 0
                ? tournamentData.totalPlayerSize
                : 1)
            } slots`}
          </div>
          <div className="player-trophies">
            <img src={TrophiesImage} />
            {tournamentData &&
              tournamentData?.trophyStructure?.map((trophy, index) => (
                <span key={index}>{trophy}</span>
              ))}
          </div>
          {tournamentData?.status === "Upcoming" && (
            <div className="share-join-button">
              <Button
                className="light-button"
                onClick={() => setShareOpen(true)}
              >
                Share
              </Button>
              {canSoloJoin && (
                <Button
                  className="Fill-button"
                  onClick={() =>
                    tournamentData?.isRegisterTournament === true
                      ? navigate(`/lobby-tournaments/${id}`)
                      : setOpen(true)
                  }
                  disabled={tournamentData.status === "Upcoming" ? false : true}
                >
                  {tournamentData.status === "Upcoming" ? "Join" : "Live"}
                </Button>
              )}
              <Button
                className="Fill-button"
                onClick={handleOpenTeamJoin}
                disabled={tournamentData.status !== "Upcoming"}
              >
                Join with Team
              </Button>
            </div>
          )}
        </div>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          className="custom-tabs mt-4"
        >
          {/* Rules Tab */}
          {/* Rules Tab */}
          <TabPane tab="Rules" key="rules">
            <div className="leaderboard-main-section">
              <div className="leaderboard-header">
                <h4>Tournament Rules</h4>
              </div>
              <div className="rules-main-list">
                <p>
                  All players must join before{" "}
                  {moment(tournamentData.startDate).format(
                    "DD MMM YYYY | HH:mm A",
                  )}
                  .
                </p>
                <p>{rules}</p>
                <p>Standard community guidelines apply.</p>
              </div>
              {/* <div className="profile-image-iname">
                <img src={ProfileImage} />
                AdminUser01
              </div> */}
            </div>
          </TabPane>
          {/* Matches Tab */}
          <TabPane tab="Matches" key="matches">
            <div className="leaderboard-main-section">
              <div className="leaderboard-header">
                <h4>Match Schedule</h4>
              </div>
              <div className="leaderboard-list">
                {brackets &&
                  Object.keys(brackets).map((item, index) => (
                    <div className="round-class-main" key={index}>
                      {brackets[item].map((match, index) => (
                        <div className="matches-list">
                          <h4>
                            <span>{`${item} - match ${index + 1}`}</span>
                          </h4>
                          <p className="match-list-team-para">
                            {`${match?.team1Id?.teamName} vs ${match?.team2Id?.teamName}`}{" "}
                          </p>
                          <p className="match-list-status-para">{`${match.status} this match`}</p>
                        </div>
                      ))}
                      <hr className="match-list-hr" />
                      {/* <h6>GamerPro vs Speedster </h6> */}
                    </div>
                  ))}
              </div>
            </div>
          </TabPane>
          {/* Bracket Tab */}
          <TabPane tab="Bracket" key="bracket">
            {/* When tournament is upcoming */}
            {tournamentData.status === "Upcoming" && (
              <div className="leaderboard-main-section mb-3">
                <div className="leaderboard-header">
                  <h4>Bracket</h4>
                  {/* <h6>View</h6> */}
                </div>
                <div className="racket-text-lok">
                  <div className="racket-text-lokinner">
                    <h6>Waiting for the host to start the match...</h6>
                    <h3>{timeLeft}</h3>
                  </div>
                </div>
              </div>
            )}

            {/* When tournament is live  */}
            {!(tournamentData.format === "BR") &&
              (tournamentData.status === "Active" ||
                tournamentData.status === "Completed") && (
                <>
                  <div className="bracket-main-section">
                    {brackets &&
                      Object.keys(brackets).map((item, index) => {
                        const isFinalRound = item === "Final";
                        // helpers per match
                        const team1Scores = item?.team1Score || [];
                        const team2Scores = item?.team2Score || [];
                        const team1Updates = item?.team1ScoreUpdates || 0;
                        const team2Updates = item?.team2ScoreUpdates || 0;

                        const showTwoBoxes =
                          isDoubleElimination && !isFinalRound; // 🔥 condition

                        return (
                          <div className="bracket-round-div-main" key={index}>
                            <div className="bracket-round-div bracket-round-div-green">
                              <h4>{item}</h4>
                              <div className="bracket-round-div-image">
                                <img src={CalanderchackGreen} />
                              </div>
                            </div>
                            {/* -------- Brackets --------- */}
                            {brackets[item].map((match, index) => (
                              <div className="final-main-div-new" key={index}>
                                <div className="semifinal-main-sections-kl">
                                  <div className="team-card-main-all-semifinal">
                                    <div className="team-card-main-all-inner">
                                      <div className="team-card-main-all">
                                        <div className="team-card-main">
                                          <div className="tram-cards">
                                            {/* ================= TEAM 1 CARD ================= */}
                                            <div className="team-red-card">
                                              <img
                                                className="team-banner-main"
                                                src={Teamredbanner}
                                              />
                                              <img
                                                className="team-banner-background"
                                                src={TeamredBg}
                                              />
                                              <img
                                                className="team-banner-logo"
                                                src={TeamredLogoFox}
                                              />
                                              {match?.winnerId?.teamId ===
                                                match?.team1Id?.teamId && (
                                                <img
                                                  className="team-banner-crown-icob"
                                                  src={WinnerCrownIcon}
                                                />
                                              )}
                                              <div className="team-banner-team-name">
                                                {match?.team1Id?.teamName}
                                              </div>
                                              {/* <div
                                                className={
                                                  match?.winnerId?.teamId ===
                                                  match?.team1Id?.teamId
                                                    ? "team-points-divv-green"
                                                    : "team-points-divv-black"
                                                }
                                              >
                                                {match?.team1Id?.score}
                                              </div> */}
                                              {/* 🔥 TEAM 1 SCORE BOXES (Single / Double) */}
                                              {showTwoBoxes ? (
                                                <>
                                                  {/* First box - index 0 */}
                                                  <div
                                                    className={
                                                      match?.winnerId
                                                        ?.teamId ===
                                                      match?.team1Id?.teamId
                                                        ? "team-points-divv-green"
                                                        : "team-points-divv-black"
                                                    }
                                                  >
                                                    {team1Scores[0] || 0}
                                                  </div>

                                                  {/* Second box - index 1 */}
                                                  <div
                                                    className={
                                                      match?.winnerId
                                                        ?.teamId ===
                                                      match?.team1Id?.teamId
                                                        ? "team-points-divv-green"
                                                        : "team-points-divv-black"
                                                    }
                                                  >
                                                    {team1Scores[1] || 0}
                                                  </div>
                                                </>
                                              ) : (
                                                // 🔥 Single elimination OR Final → single box only
                                                <div
                                                  className={
                                                    match?.winnerId?.teamId ===
                                                    match?.team1Id?.teamId
                                                      ? "team-points-divv-green"
                                                      : "team-points-divv-black"
                                                  }
                                                  style={{
                                                    cursor:
                                                      tournamentData?.status ===
                                                      "Active"
                                                        ? "pointer"
                                                        : "default",
                                                  }}
                                                >
                                                  {team1Scores[0] || 0}
                                                </div>
                                              )}
                                            </div>

                                            {/* ================= VS ================= */}
                                            <div className="winner-time">
                                              <span> VS</span>
                                            </div>

                                            {/* ================= TEAM 2 CARD ================= */}
                                            <div className="team-green-card">
                                              <img
                                                className="team-banner-main"
                                                src={Teamredbanner}
                                              />
                                              <img
                                                className="team-banner-background"
                                                src={TeamredBg}
                                              />
                                              <img
                                                className="team-banner-logo"
                                                src={TeamredLogoBull}
                                              />
                                              {match?.winnerId?.teamId ===
                                                match?.team2Id?.teamId && (
                                                <img
                                                  className="team-banner-crown-icob"
                                                  src={WinnerCrownIcon}
                                                />
                                              )}
                                              <div className="team-banner-team-name">
                                                {match?.team2Id?.teamName}
                                              </div>
                                              {/* <div
                                                className={
                                                  match?.winnerId?.teamId ===
                                                  match?.team2Id?.teamId
                                                    ? "team-points-divv-green"
                                                    : "team-points-divv-black"
                                                }
                                              >
                                                {match?.team2Id?.score}
                                              </div> */}
                                              {/* 🔥 TEAM 2 SCORE BOXES (Single / Double) */}
                                              {showTwoBoxes ? (
                                                <>
                                                  {/* First box - index 0 */}
                                                  <div
                                                    className={
                                                      match?.winnerId
                                                        ?.teamId ===
                                                      match?.team2Id?.teamId
                                                        ? "team-points-divv-green"
                                                        : "team-points-divv-black"
                                                    }
                                                    style={{
                                                      cursor:
                                                        tournamentData?.status ===
                                                        "Active"
                                                          ? "pointer"
                                                          : "default",
                                                    }}
                                                  >
                                                    {team2Scores[0] || 0}
                                                  </div>

                                                  {/* Second box - index 1 */}
                                                  <div
                                                    className={
                                                      match?.winnerId
                                                        ?.teamId ===
                                                      match?.team2Id?.teamId
                                                        ? "team-points-divv-green"
                                                        : "team-points-divv-black"
                                                    }
                                                    style={{
                                                      cursor:
                                                        tournamentData?.status ===
                                                        "Active"
                                                          ? "pointer"
                                                          : "default",
                                                    }}
                                                  >
                                                    {team2Scores[1] || 0}
                                                  </div>
                                                </>
                                              ) : (
                                                // 🔥 Single elim or Final → single score box
                                                <div
                                                  className={
                                                    match?.winnerId?.teamId ===
                                                    match?.team2Id?.teamId
                                                      ? "team-points-divv-green"
                                                      : "team-points-divv-black"
                                                  }
                                                  style={{
                                                    cursor:
                                                      tournamentData?.status ===
                                                      "Active"
                                                        ? "pointer"
                                                        : "default",
                                                  }}
                                                >
                                                  {team2Scores[0] || 0}
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        );
                      })}
                  </div>
                </>
              )}

            {/* When tournament format is BR */}
            {tournamentData.format === "BR" &&
              (tournamentData.status === "Active" ||
                tournamentData.status === "Completed") && (
                <>
                  <div className="bracket-main-section">
                    {brackets &&
                      Object.keys(brackets).map((item, index) => (
                        <div className="bracket-round-div-main" key={index}>
                          <div className="bracket-round-div bracket-round-div-green">
                            <h4>{item}</h4>
                            <div className="bracket-round-div-image">
                              <img src={CalanderchackGreen} />
                            </div>
                          </div>
                          {/* Brackets */}
                          <div>
                            {brackets["Final"]?.map((match) => (
                              <section key={match._id}>
                                <div className="br-match-container">
                                  {match.participants.map((p) => (
                                    <div
                                      key={p.team._id}
                                      className="br-team-card"
                                    >
                                      <div className="br-team-content">
                                        <img
                                          src={
                                            isValidUrl(p?.team?.image)
                                              ? p.team.image
                                              : TeamredLogoBull
                                          }
                                          className="br-team-image"
                                          alt={p.team.teamName}
                                        />

                                        <div className="br-team-info">
                                          <div className="br-team-name">
                                            {p.team.teamName}
                                          </div>
                                          <div className="br-team-id">
                                            {p.team.teamId}
                                          </div>

                                          {/* Winner Icon */}
                                          {match?.winnerId &&
                                            match?.winnerId?._id ===
                                              p.team._id && (
                                              <img
                                                src={WinnerCrownIcon}
                                                alt="winner"
                                                className="br-winner-crown"
                                              />
                                            )}
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </section>
                            ))}
                          </div>
                        </div>
                      ))}
                  </div>
                </>
              )}
          </TabPane>
        </Tabs>
      </div>
      {/* Share Modal */}
      <UniversalShareModal
        open={shareOpen}
        onClose={() => setShareOpen(false)}
        url={window.location.href}
      />
      {/* Join tournament modal */}
      <JoinTournamentModal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        data={tournamentData}
        profile={profile}
        onJoin={(tournamentId) => handleRegister(tournamentId)}
      />
      {/* Join with team modal */}
      <Modal
        open={teamJoinOpen}
        onCancel={() => setTeamJoinOpen(false)}
        footer={null}
        centered
        className="join-upcoming-tournament-modal"
      >
        <div className="join-upcoming-tournament-wrapper">
          <h2 className="join-upcoming-tournament-title">Join with Team</h2>

          <p className="join-upcoming-tournament-desc">
            Select up to {maxSelectableFriends} friends from your followers and
            following. Your team will have {totalPlayerSize} players including
            you.
          </p>

          <Select
            mode="multiple"
            allowClear
            showSearch
            style={{ width: "100%", marginBottom: 16 }}
            placeholder={
              loadingConnections
                ? "Loading friends..."
                : "Select friends to invite"
            }
            value={selectedInviteeIds}
            onChange={handleTeamInviteChange}
            loading={loadingConnections}
            optionFilterProp="label"
            options={teamInviteOptions.map((user) => ({
              label: user?.name || user?.userId,
              value: user?._id,
            }))}
          />

          <div className="join-upcoming-tournament-info">
            <div>
              <span>Selected Players</span>
              <strong>
                {totalPlayersInTeam} / {totalPlayerSize}
              </strong>
            </div>
            <div>
              <span>Total Entry Fee</span>
              <strong>
                {totalTeamFee} {tokenLabel}
              </strong>
            </div>
          </div>

          <div
            className="join-upcoming-tournament-info"
            style={{ marginTop: 8 }}
          >
            <div>
              <span>Your Balance</span>
              <strong>
                {balance.toFixed(2)} {tokenLabel}
              </strong>
            </div>
            <div>
              <span>Entry Fee per Player</span>
              <strong>
                {entryFee} {tokenLabel}
              </strong>
            </div>
          </div>

          {!hasEnoughBalanceForTeam && totalTeamFee > 0 && (
            <p className="join-upcoming-tournament-desc error">
              You don’t have sufficient tokens to join with this many players.
            </p>
          )}

          <div className="join-upcoming-tournament-actions">
            <Button
              className="join-upcoming-tournament-back-btn Fill-button"
              onClick={() => setTeamJoinOpen(false)}
            >
              Back
            </Button>

            <Button
              className="join-upcoming-tournament-join-btn Fill-button"
              onClick={handleConfirmTeamJoin}
              disabled={
                !canSoloJoin &&
                (!isExactTeamSize ||
                  !hasEnoughBalanceForTeam ||
                  loadingConnections)
              }
            >
              Continue
            </Button>
          </div>
        </div>
      </Modal>
    </Main>
  );
};

export default TournamentsDetails;
